export default "__VITE_PUBLIC_ASSET__f13f0688__"